<template>
    <div>
        <div class="d-flex" id="container">
            <span class="p-2 mt-1">
                <i class="fa fa-plus cursor-pointer" @click="showDetails" v-if="!details"></i>
                <i class="fa fa-minus cursor-pointer" @click="showDetails" v-if="details"></i>
            </span>
            <div class="card">
                <div class="card-header m-0">
                    <div class="d-flex justify-content-between" id="invite-details">
                        <span class="item">
                            <input type="checkbox" class="mr-2"
                                   v-model="selectedInvite"
                                   :id="'invites-' + invites.id"
                                   @change="select(invites)"
                                   :value="invites.id"
                            />
                            <span class="mr-2">{{ name | maxSizeString(19) }}</span>
                        </span>

                        <span class="item">
                            <i class="fa fa-phone mr-1"></i>
                            <span v-if="phoneNumber">
                                {{ phoneNumber | maxSizeString }}
                            </span>
                            <span v-if="!phoneNumber">
                                <em class="text-muted mr-2">
                                    No phone number
                                </em>
                            </span>
                        </span>

                        <span class="item" style="flex-grow: 1;">
                            <i class="fa fa-envelope mr-1"></i>
                            <span v-if="email">
                                {{ email | maxSizeString }}
                            </span>
                            <span v-if="!email">
                                <em class="text-muted">No email</em>
                            </span>
                        </span>

                        <span class="item">
                            <i class="far fa-calendar-alt mr-1"></i>
                            <span v-if="sentAt">
                                {{ sentAt | inviteDate(timezone) }}
                            </span>
                            <span v-if="!sentAt">
                                <em class="text-muted">Not sent</em>
                            </span>
                        </span>

                        <span id="status" style="flex: 0.5">
                            <div class="small" :style="statusColor">
                                {{ status }}
                            </div>
                        </span>

                        <span>{{ invites.id }}</span>
                    </div>
                </div>
                <transition name="fade-in-down">
                    <div class="card-body p-0" v-if="details">
                        <grid-content>
                            <grid-content-row>
                                <location-info :invite="invites" :timezone="timezone" @change-status="changeStatus"></location-info>
                            </grid-content-row>
                            <grid-content-row>
                                <tags v-model="invites.tags" :options="tags" @input="updateInvite(invites)"></tags>
                            </grid-content-row>
                        </grid-content>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import LocationInfo from "./InviteLocationInfo";
    import _            from "lodash";

    export default {
        props: ["invites", "tags", "selectedInvites"],

        data: () => ({
            timezone: null,
            details: false
        }),

        filters: {
            maxSizeString(value, size = 15) {
                return value.length > size
                    ? value.substring(0, size - 2) + "..."
                    : value;
            },
            inviteDate(value, timezone){
                let date;
                if (!timezone){
                    timezone = 'MST';
                }
                if (_.has(value, 'date')) {
                    date = moment.tz(value.date, 'UTC').tz(timezone);
                }

                if (moment(value).isValid()) {
                    date = moment.tz(value, 'UTC').tz(timezone);
                }

                if (date) {
                    return date.format('YYYY/MM/DD LT');
                }

                return value;
            }
        },

        components: {
            LocationInfo
        },
        created(){
            this.fetchTimezone();
        },
        computed: {
            selectedInvite: {
                get() {
                    return this.selectedInvites;
                },
                set() {}
            },
            name() {
                return this.invites.contact.name;
            },
            email() {
                return this.invites.contact.email;
            },
            phoneNumber() {
                return this.invites.contact.phone_number;
            },
            sentAt() {
                return this.invites.sent_at;
            },
            status() {
                if (this.invites.status === "shared") return "clicked";

                return this.invites.status;
            },
            isShared() {
                return this.status === "clicked";
            },
            isExpired() {
                return this.status === "expired";
            },
            isScheduled() {
                return this.status === "scheduled";
            },
            isSent() {
                return this.status === "sent";
            },
            isFailed() {
                return this.status === "failed";
            },
            isOpened() {
                return this.status === "opened";
            },
            isQueued() {
                return this.status === "queued";
            },
            isPending() {
                return this.status === "pending";
            },
            isInitiated() {
                return this.status === "initiated";
            },
            isStopped() {
                return this.status === "stopped";
            },
            statusDefaultStyle() {
                return `width: 77px; color: #fff; text-align: center; border-radius: 7px;`;
            },

            statusColor() {
                if (this.isStopped) {
                    return `background: #a9144fcc; ${this.statusDefaultStyle}`;
                }
                if (this.isInitiated) {
                    return `background: #331862a6; ${this.statusDefaultStyle}`;
                }
                if (this.isShared) {
                    return `background: #249D68; ${this.statusDefaultStyle}`;
                }
                if (this.isExpired) {
                    return `background: #609daf; ${this.statusDefaultStyle}`;
                }
                if (this.isScheduled) {
                    return `background: #FFB90D; ${this.statusDefaultStyle}`;
                }
                if (this.isSent) {
                    return `background: #616A72; ${this.statusDefaultStyle}`;
                }
                if (this.isFailed) {
                    return `background: #D72E3D; ${this.statusDefaultStyle}`;
                }
                if (this.isOpened) {
                    return `background: #0070FF; ${this.statusDefaultStyle}`;
                }
                if (this.isQueued) {
                    return `background: #563d7c; ${this.statusDefaultStyle}`;
                }
                if (this.isPending) {
                    return `background: #D72E3D; ${this.statusDefaultStyle}`;
                }
            }
        },

        methods: {
            fetchTimezone()  {
                return this.$http.get(this.$laroute.route('api.teams.current-team-timezone')).then(({ data }) => {
                    this.timezone = data;
                });
            },
            showDetails() {
                this.details = !this.details;
            },
            select(value) {
                this.$emit("selected", value);
            },
            changeStatus(value) {
                this.invites.status = value;
            }
        }
    };
</script>


<style lang="scss" scoped>
    .d-flex {
        flex-wrap: wrap;
    }

    .item {
        flex: 1 1;
    }

    .card {
        border-radius: 0;
        flex-grow: 1;
    }

    #container {
        margin-bottom: -20px;
    }

    @media screen and (max-width: 991px) {
        #container {
            flex-direction: column;
            align-items: center;
        }

        #status {
            margin: auto;
        }

        .card {
            width: 100%;
        }

        #invite-details {
            flex-direction: column;
            text-align: center;
        }

        .item:not(:last-child) {
            margin-bottom: 10px;
        }
    }
</style>
